// Legacy K-12 taxonomy. Preserved ONLY for backward-compatibility of
// pre-Sayısal user profiles and legacy chat routes. NEW acquisition /
// onboarding surfaces MUST use `SAYISAL_TIERS` below (Track C).
export const GRADE_LEVELS = [
  { value: "5", label: "5. Sınıf" },
  { value: "6", label: "6. Sınıf" },
  { value: "7", label: "7. Sınıf" },
  { value: "8", label: "8. Sınıf" },
  { value: "9", label: "9. Sınıf" },
  { value: "10", label: "10. Sınıf" },
  { value: "11", label: "11. Sınıf" },
  { value: "12", label: "12. Sınıf" },
  { value: "LGS", label: "LGS" },
  { value: "YKS", label: "YKS" },
];

export const COURSES = [
  "Matematik",
  "Türkçe",
  "Fen Bilimleri",
  "Fizik",
  "Kimya",
  "Biyoloji",
  "Tarih",
  "Coğrafya",
  "İngilizce",
];

// Canonical Sayısal V1 tier list — mirrors backend
// `slos.sayisal.tiers.SAYISAL_TIERS`. Fine-grained topics arrive via
// the Exam Intelligence package interface; never hard-coded here.
export const SAYISAL_TIERS = [
  {
    value: "LGS_SAY",
    label: "LGS Sayısal",
    hint: "8. sınıf · Matematik + Fen Bilimleri",
  },
  {
    value: "TYT_SAY",
    label: "TYT Sayısal",
    hint: "Mat + Fizik + Kimya + Biyoloji",
  },
  {
    value: "AYT_SAY",
    label: "AYT Sayısal",
    hint: "Mat + Fizik + Kimya + Biyoloji",
  },
];

export function labelForSayisalTier(v) {
  const found = SAYISAL_TIERS.find((t) => t.value === v);
  return found ? found.label : v;
}

export function labelForGrade(v) {
  const found = GRADE_LEVELS.find((g) => g.value === v);
  return found ? found.label : v;
}
